export type EmailChangeRequestResponse = {
  oldEmail: string
  newEmail: string
  expiresAt: string
}

export const makeEmailChangeRequestViewModel = (response: EmailChangeRequestResponse): EmailChangeRequestViewModel => {
  const { oldEmail, newEmail } = response
  const currentDate = new Date()
  const expiresAt = new Date(response.expiresAt)
  const isExpired = expiresAt < currentDate

  return {
    oldEmail,
    newEmail,
    expiresAt,
    isExpired,
  }
}

export type EmailChangeRequestViewModel = {
  oldEmail: string
  newEmail: string
  expiresAt: Date
  isExpired: boolean
}
